import { createAction, props } from '@ngrx/store';

import { type UploaderOptions } from '../../../domain/public-api';

export const resetSettingsState = createAction('[Settings] Reset state');

export const setUploaderOptions = createAction(
  '[Settings] Set uploader options',
  props<{ options: UploaderOptions }>(),
);
